import Headers from "../../config/headers";
import LocalStorageFunc from "../../helpers/localStorageFunc";
import ApiCalls from "../../config/apiCalls";
import Utility from "../../helpers/utility";
import { MINIAPP, ORDER_TYPE } from "../../helpers/paymentConstants";
import apiCalls from "../../config/apiCalls";
import headers from "../../config/headers";
import loginSuccess from "../../helpers/login";
import utility from "../../helpers/utility";
import { setAmbitUserId } from "../../helpers/events";

export default {
  namespaced: true,
  state: {
    isLoggedIn: false,
    loginMessageDynamicText: [
      "Exclusive Offers",
      "Saved addresses",
      "Free Pizza rewards",
      "Best experience",
    ],
    isSessionPresent: LocalStorageFunc.cartId() ? true : false,
    qrOrder: LocalStorageFunc.getIsQrOrder() || false,
  },
  getters: {},
  mutations: {
    updateLoginMessageDynamicText(state, payload) {
      if (payload) {
        state.loginMessageDynamicText = payload;
      }
    },
    updateLogginState(state, payload) {
      LocalStorageFunc.updateIsLoggedIn(payload);
      state.isLoggedIn = payload.isLoggedIn;
      const userId = LocalStorageFunc.getUserId();
      if (userId) {
        setAmbitUserId(userId);
      } else {
        setAmbitUserId(null);
      }
    },
    createLocalStorageUserInfo(state, payload) {
      let value = {
        headers: {
          isLoggedIn: false,
          deliveryType: "D",
          ...payload,
        },
      };
      const queryObj = Utility.getQueryFromUrlWithSpace(window.location.href);
      const qrOrder = state.qrOrder;
      const cateogryTypeDineInTakeAway =
        window.location.href.includes("/qr") &&
        Utility.getLinkRewriteFromSiteprops() === "qr" &&
        ((queryObj["ordertype"] || queryObj["orderType"])?.toUpperCase() ||
          ORDER_TYPE.DINEIN);
      const getLocalStorageDelType = LocalStorageFunc.getDeliveryType();
      if (cateogryTypeDineInTakeAway) {
        value.headers.deliveryType = cateogryTypeDineInTakeAway;
      } else if (qrOrder === true) {
        value.headers.deliveryType = getLocalStorageDelType;
      }
      localStorage.userInfo = JSON.stringify(value);
      state.isLoggedIn = false;
    },
    updateLocalStorageUserInfoCredential(state, payload) {
      let value = localStorage.userInfo
        ? Utility.tryJsonParse(localStorage.userInfo)
        : "";
      try {
        if (payload.sessionToken) {
          value.headers.credentials = {
            accessKeyId: payload.accessKeyId,
            secretKey: payload.secretKey,
            sessionToken: payload.sessionToken,
          };
        } else {
          value.headers.credentials = {
            ...value.headers.credentials,
            accessKeyId: payload.accessToken,
            refreshToken: payload.refreshToken,
          };
        }
        localStorage.userInfo = JSON.stringify(value);
      } catch (e) {
        state.isLoggedIn = false;
      }
    },
    updateIsSessionPresent(state, payload) {
      state.isSessionPresent = payload;
    },
    updateQrOrder(state, payload) {
      state.qrOrder = payload;
    },
  },
  actions: {
    anonymousUserApi({ commit }, payload) {
      ApiCalls.ANONYNMOUS_USER_API({
        headers: Headers(),
        payload: {},
      })
        .then(function (response) {
          if (response?.data?.cartId) {
            commit("createLocalStorageUserInfo", response.data);
            LocalStorageFunc.unsetKey("userAddresses");
            if (payload.cleareAddress) {
              LocalStorageFunc.unsetKey("addressDetail");
              LocalStorageFunc.unsetKey("selectedAddress");
            }
            if (typeof payload.startupAppiCalls === "function") {
              payload.startupAppiCalls();
            } else {
              location.reload();
            }
          }
          commit("updateIsSessionPresent", true);
        })
        .catch(function (error) {
          commit("updateIsSessionPresent", true);
        });
    },
    loadLoginStatus({ commit, dispatch }, payload) {
      commit("updateLogginState", {
        isLoggedIn: LocalStorageFunc.isLoggedIn() || false,
      });
    },
    signInMiniApp({ commit, dispatch }, payload) {
      try {
        let loginPayload = {};
        if (payload.partnerName === MINIAPP.PAYTM) {
          loginPayload = {
            authCode: payload?.data?.authId || "",
            clientId: payload?.data?.openId || "",
            vendor: "paytm",
          };
        } else if (payload.partnerName === MINIAPP.GPAY) {
          loginPayload = {
            authCode: payload?.identityRes || "",
            clientId: payload?.phoneNumber || "",
            vendor: "googlepay",
          };
        }
        apiCalls
          .SIGN_IN_MINIAPP({
            headers: headers(),
            payload: loginPayload,
          })
          .then((response) => {
            if (response?.data) {
              const res = response.data;
              const {
                cartId,
                cognitoLoggedin,
                email,
                emailVerified,
                firstName,
                lastName,
                mobile,
                phoneNumberVerified,
                sub,
                userId,
              } = res.attributes;
              const userData = {
                url: "/",
                cartId,
                cognitoId: res.cognitoId,
                cognitoLoggedin,
                email,
                emailVerified,
                firstName,
                lastName,
                mobile,
                phoneNumberVerified,
                sub,
                userId,
                isLoggedIn: true,
              };
              const loginSuccessPayload = {
                userData,
                credentials: res.credentials,
              };
              loginSuccess(loginSuccessPayload);
            }
          })
          .catch((error) => {
            console.error("GET SIGNIN MINIAPP Error: ", error);
            utility.redirectToLoginScreen();
          });
      } catch (error) {
        console.error("ERROR: signInMiniApp: ", error);
        utility.redirectToLoginScreen();
      }
    },
  },
};
